import React, { Fragment, memo } from "react";
import { useRecoilState, useRecoilValue } from "recoil";

import { examOrderState } from '../../../store/examOrderState';
import { orderInfoState } from '../../../store/orderInfoState';

export const CheckupInfo = memo(() => {
  // const examOrderData = useRecoilValue(examOrderState);
  const [examOrderData, setExamOrderData] = useRecoilState(examOrderState);
  const orderInfoData = useRecoilValue(orderInfoState);

  const displayOptionNames = (options) => {
    var dispName = [];
    options.map(option => {
      dispName.push(option.option_name);
    })
    return dispName.join(', ');
  }

  const onClickClinic = () => {
    setExamOrderData({
      ...examOrderData,
      examclinic: orderInfoData.requestclinic,
      examclinic_id: orderInfoData.requestclinic_id,
    });
  }

  const onClickDate = (dt_value, dtime_value) => {
    var examdtime_val = '00:00';
    if (dtime_value == '午前') {
      examdtime_val = '09:00';
    } else if (dtime_value == '午後') {
      examdtime_val = '13:00';
    }
    setExamOrderData({
      ...examOrderData,
      examdtdate: dt_value,
      examdtime: examdtime_val,
    });
  }

  const displayStatusName = (status) => {
    switch(status){
      case 'order_init':
        return '申込中';
      case 'order_changed':
        return '申込変更中';
      case 'order_readjusted':
        return '再調整';
      case 'order_commited':
        return '予約確定';
      case 'order_finished':
        return '受診確認完了';
      case 'order_not_ineligible':
        return '対象外(未受診)';
      default:
        return '未申込'
    }
  }

  const switchDetailDisplay = () => {
    if (orderInfoData.status === 'order_commited' || orderInfoData.status === 'order_finished') {
      return (
        <Fragment>
          <tr>
            <th className="w-25">申し込み管理No.</th>
            <td>{orderInfoData.id}</td>
          </tr>
          <tr>
            <th>ステータス</th>
            <td>{displayStatusName(orderInfoData.status)}</td>
          </tr>
          <tr>
            <td className="td-head" colSpan="2">
              &#8810; 健診コース &#8811;
            </td>
          </tr>
          <tr>
            <th>コース</th>
            <td>{orderInfoData.requestcource}</td>
          </tr>
          <tr>
            <th>コースコード</th>
            <td>{orderInfoData.cource_code}</td>
          </tr>
          <tr>
            <th>オプション</th>
            <td>{displayOptionNames(orderInfoData.options)}</td>
          </tr>
          <tr>
            <th>備考・御要望など</th>
            <td className="note">{orderInfoData.requestnote}</td>
          </tr>
          <tr>
            <th>概算費用[申込時点]</th>
            <td className="note">
              <p>
                <span className="fw-bold text-danger">自己負担金額</span>：
                &#xFFE5; {orderInfoData.result_price}
              </p>
              <p>
                <span className="fw-bold">申込内容金額：</span>
                &#xFFE5; {orderInfoData.calc_price}
              </p>
            </td>
          </tr>
        </Fragment>
      )
    } else if (orderInfoData.status === 'order_not_ineligible') {
      return (
        <Fragment>
          <tr>
            <th className="w-25">申し込み管理No.</th>
            <td>{orderInfoData.id}</td>
          </tr>
          <tr>
            <th>ステータス</th>
            <td>{displayStatusName(orderInfoData.status)}</td>
          </tr>
        </Fragment>
      )
    } else {
      return (
        <Fragment>
          <tr>
            <th className="w-25">申し込み管理No.</th>
            <td>{orderInfoData.id}</td>
          </tr>
          <tr>
            <th>ステータス</th>
            <td>{displayStatusName(orderInfoData.status)}</td>
          </tr>
          <tr>
            <td className="td-head" colSpan="2">
              &#8810; 希望健診コース &#8811;
            </td>
          </tr>
          <tr>
            <th>コース</th>
            <td>{orderInfoData.requestcource}</td>
          </tr>
          <tr>
            <th>コースコード</th>
            <td>{orderInfoData.cource_code}</td>
          </tr>
          <tr>
            <th>オプション</th>
            <td>{displayOptionNames(orderInfoData.options)}</td>
          </tr>
          <tr>
            <th>備考・御要望など</th>
            <td className="note">{orderInfoData.requestnote}</td>
          </tr>
          <tr>
            <th>概算費用[申込時点]</th>
            <td className="note">
              <p>
                <span className="fw-bold text-danger">自己負担金額</span>：
                &#xFFE5; {orderInfoData.result_price}
              </p>
              <p>
                <span className="fw-bold">申込内容金額：</span>
                &#xFFE5; {orderInfoData.calc_price}
              </p>
            </td>
          </tr>
          <tr>
            <td className="td-head" colSpan="2">
              &#8810; 希望医療機関 &#8811;
            </td>
          </tr>
          <tr>
            <th>受診先地域</th>
            <td>{orderInfoData.requestpref_name}</td>
          </tr>
          <tr>
            <th>医療機関</th>
            <td>
              <button onClick={onClickClinic} className="btn btn-outline-info btn-sm mr-1">転記</button>
              {orderInfoData.requestclinic}
            </td>
          </tr>
          <tr>
            <td className="td-head" colSpan="2">
              &#8810; 受診希望日 &#8811;
            </td>
          </tr>
          <tr>
            <th>第1受診希望日</th>
            <td>
              <button onClick={() => onClickDate(orderInfoData.requestdt1, orderInfoData.requestdt1_ampm)} className="btn btn-outline-info btn-sm mr-1">転記</button>
              {orderInfoData.requestdt1} {orderInfoData.requestdt1_ampm}
            </td>
          </tr>
          <tr>
            <th>第2受診希望日</th>
            <td>
              <button onClick={() => onClickDate(orderInfoData.requestdt2, orderInfoData.requestdt2_ampm)} className="btn btn-outline-info btn-sm mr-1">転記</button>
              {orderInfoData.requestdt2} {orderInfoData.requestdt2_ampm}
            </td>
          </tr>
          <tr>
            <th>第3受診希望日</th>
            <td>
            <button onClick={() => onClickDate(orderInfoData.requestdt3, orderInfoData.requestdt3_ampm)} className="btn btn-outline-info btn-sm mr-1">転記</button>
              {orderInfoData.requestdt3} {orderInfoData.requestdt3_ampm}
            </td>
          </tr>
        </Fragment>
      )
    }
  }

  return (
    <>
      <div className="accordion-item">
        <h2 className="accordion-header" id="panelsStayOpen-headingCheckup">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseCheckup" aria-expanded="false" aria-controls="panelsStayOpen-collapseCheckup">
            申込情報
            </button>
        </h2>
        <div id="panelsStayOpen-collapseCheckup" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingCheckup">
          <div className="accordion-body bg-white">
            <table className="table table-striped mt-3">
              <tbody>
                { examOrderData.id ?
                  <Fragment>{ switchDetailDisplay() }</Fragment>
                :
                  <tr>
                    <td colSpan="2">
                      申込は存在しません。
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
});
